import breaks from '@bytemd/plugin-breaks';
import gfm from '@bytemd/plugin-gfm';
import gfmLocale from '@bytemd/plugin-gfm/locales/zh_Hans.json';
import type { BytemdPlugin } from 'bytemd';
import { linkTargetBlank } from './linkTargetBlank';

export const markdownPlugins: BytemdPlugin[] = [
  gfm({ locale: gfmLocale }),
  breaks(),
  linkTargetBlank(),
];
